import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NodeRowProps } from '../../types';
import useNodeInfo from '../../hooks/useNodeInfo';
import FileAccessCheckboxes from '../FileAccessCheckboxes';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import DataRoomNodeTagAndVersion from 'components/DataRoomNodeTagAndVersion';
import { getNodeMimeType } from 'utils';
import { isMaximumSelected } from 'router/subrouters/DataRoom/utils';

import './FileNodeRow.styles.scss';

const FileNodeRow: React.FC<NodeRowProps> = (props) => {
  const { className, node, ...rest } = props;
  const { orderStageCopies } = rest;

  const { name, tag, version, _id, fileSecurity, releaseOrderStep } =
    node || {};

  const classes = classNames('file-node-row', className);

  const { t } = useTranslation();

  const createInfoData = useNodeInfo();

  const orderStage = releaseOrderStep && orderStageCopies?.[releaseOrderStep];

  return (
    <div className={classes}>
      <div className="file-access-selector__node-info">
        <MymeTypeIcon
          mimeType={getNodeMimeType(node)}
          isLocked={isMaximumSelected(fileSecurity)}
        />
        <span>
          <p className="name">
            <span>{name}</span>
            <DataRoomNodeTagAndVersion tag={tag} version={version} />
          </p>
          {createInfoData(
            node,
            orderStage && t('inStageOrder', { stage: orderStage }),
          )}
        </span>
      </div>

      <FileAccessCheckboxes id={_id} node={node} {...rest} />
    </div>
  );
};

export default FileNodeRow;
